var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5502 12L22.3825 4.03857C22.8513 3.46019 22.8177 2.6096 22.2485 2.13328L20.239 0.364072C19.6696 -0.112254 18.8323 -0.07823 18.3635 0.500164L12 7.84918L5.67009 0.466141C5.20121 -0.112254 4.33043 -0.146277 3.79456 0.330048L1.78507 2.09926C1.21571 2.57558 1.18221 3.46019 1.6511 4.00455L8.44989 12L1.6176 19.9615C1.14872 20.5399 1.18221 21.3904 1.75157 21.8667L3.76106 23.636C4.33043 24.1123 5.16771 24.0783 5.63659 23.4999L12 16.1508L18.3299 23.5338C18.7987 24.1123 19.6696 24.1463 20.2055 23.67L22.215 21.9008C22.7844 21.4244 22.8177 20.5399 22.3489 19.9954L15.5502 12Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
